import React, { useState } from 'react';
import { NavigationEyebrow } from './navigation/NavigationEyebrow';
import { NavigationLogo } from './navigation/NavigationLogo';
import { NavigationDesktopMenu } from './navigation/NavigationDesktopMenu';
import { NavigationContact } from './navigation/NavigationContact';
import { NavigationMobileMenu } from './navigation/NavigationMobileMenu';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <NavigationEyebrow data-id="element-85" />

      {/* Main Navigation */}
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 py-2 px-4 shadow-sm" data-id="element-86">
        <div className="max-w-7xl mx-auto" data-id="element-87">
          <div className="flex justify-between items-center" data-id="element-88">
            <NavigationLogo data-id="element-89" />
            <NavigationDesktopMenu data-id="element-90" />
            <NavigationContact data-id="element-91" />
            <NavigationMobileMenu isOpen={isOpen} setIsOpen={setIsOpen} data-id="element-92" />
          </div>
        </div>
      </nav>
    </>;
}